import React, { useState } from 'react';
import LazyImage from '@/components/LazyImage'; // 确保路径正确

const Content3 = () => {
    const menuItems = [
        { normal: '1', hover: '1 B' },
        { normal: '2', hover: '2 B' },
        { normal: '3', hover: '3 B' },
        { normal: '4', hover: '4 B' },
        { normal: '5', hover: '5 B' },
        { normal: '6', hover: '6 B' },
        { normal: '7', hover: '7 B' },
        { normal: '8', hover: '8 B' },
    ];

    const [hoveredIndex, setHoveredIndex] = useState(null);

    const handleClick = (item, index) => {
        window.location.href = `#/detail?normal=${item.normal}`;
    };

    const renderImageGroup = (start, end) => {
        return menuItems.slice(start, end).map((item, index) => {
            const absoluteIndex = start + index;
            return (
                <div
                    key={absoluteIndex}
                    style={{
                        width: '25%',
                        position: 'relative',
                        overflow: 'hidden',
                        cursor: 'pointer'
                    }}
                    onMouseEnter={() => setHoveredIndex(absoluteIndex)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    onClick={() => handleClick(item, absoluteIndex)}
                >
                    <LazyImage
                        alt=''
                        src={require(`@/assets/image/8img/${item.normal}.jpg`)}
                        style={{
                            width: '100%',
                            margin: 0,
                            position: 'absolute',
                            opacity: hoveredIndex === absoluteIndex ? 0 : 1,
                            transition: 'opacity 0.4s ease-out',
                        }}
                    />
                    <LazyImage
                        alt=''
                        src={require(`@/assets/image/8img/${item.hover}.jpg`)}
                        style={{
                            width: '100%',
                            margin: 0,
                            position: 'relative',
                            opacity: hoveredIndex === absoluteIndex ? 1 : 0,
                            transition: 'opacity 0.2s ease-in',
                        }}
                    />
                </div>
            );
        });
    };

    return (
        <div className='engagement' id="engagement">
            <div style={{ display: 'flex', margin: 0 }}>{renderImageGroup(0, 4)}</div>
            <LazyImage
                alt=''
                src={require('@/assets/image/8img/5i.jpg')}
                style={{ width: '100%', margin: 0 }}
            />
            <div style={{ display: 'flex', margin: 0 }}>{renderImageGroup(4, 8)}</div>
        </div>
    );
};

export default Content3;
